import React from "react"
import SingleUnitPreview from "../../components/stateful/listing/single-unit/preview/single-unit-preview";

const Preview = () => {
    return(
        <>
            <SingleUnitPreview/>
        </>
    )
}
export default Preview
